// extracted by mini-css-extract-plugin
export var success = "transaction-state-module--success--3JaEB";
export var failure = "transaction-state-module--failure--97KHW";